import type { IMapQueue } from './types';

export class SizeLimitedFifoMapQueue<K, V> implements IMapQueue<K, V> {
  private _orderedKeys: K[];
  private _map: Map<K, V>;
  private _sizeLimit: number;

  constructor(size: number) {
    this._orderedKeys = [];
    this._map = new Map<K, V>();
    this._sizeLimit = size < 0 ? 0 : size;
  }

  private _resize() {
    while (this._map.size - this._sizeLimit > 0) {
      const firstEntryKey = this._orderedKeys.shift();

      if (!firstEntryKey) return;

      this._map.delete(firstEntryKey);
    }
  }

  set(key: K, value: V): this {
    this._orderedKeys.push(key);
    this._map.set(key, value);
    this._resize();
    return this;
  }

  get(key: K): V | undefined {
    return this._map.get(key);
  }

  clear(): this {
    this._orderedKeys = [];
    this._map.clear();
    return this;
  }

  delete(key: K): boolean {
    this._orderedKeys = this._orderedKeys.filter(item => item !== key);
    return this._map.delete(key);
  }

  get size(): number {
    return this._map.size;
  }

  get sizeLimit(): number {
    return this._sizeLimit;
  }

  set sizeLimit(size: number) {
    this._sizeLimit = size;
    this._resize();
  }
}
